import React, { useState } from 'react';
import { FunnelIcon, XMarkIcon } from '@heroicons/react/24/outline';

const FilterPanel = ({ filters, onFilterChange, onReset, uniqueValues = {} }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleFilterChange = (key, value) => {
    onFilterChange({ ...filters, [key]: value });
  };

  const hasActiveFilters = Object.values(filters).some(value => value && value !== '');

  return (
    <div className="mb-6">
      {/* Toggle Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`btn-primary flex items-center gap-2 mb-4 ${hasActiveFilters ? 'ring-2 ring-success' : ''}`}
      >
        <FunnelIcon className="w-5 h-5" />
        Filtros Avançados
        {hasActiveFilters && (
          <span className="bg-success text-white rounded-full px-2 py-1 text-xs font-bold">
            {Object.values(filters).filter(value => value && value !== '').length}
          </span>
        )}
      </button>

      {/* Filter Panel */}
      {isOpen && (
        <div className="card-dark p-6 space-y-4">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-lg font-semibold text-dark-text">Filtrar Ordens</h3>
            <div className="flex gap-2">
              <button
                onClick={onReset}
                className="btn-secondary flex items-center gap-2"
              >
                <XMarkIcon className="w-4 h-4" />
                Limpar
              </button>
              <button
                onClick={() => setIsOpen(false)}
                className="btn-secondary"
              >
                <XMarkIcon className="w-5 h-5" />
              </button>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {/* Status */}
            <div>
              <label className="block text-sm font-medium text-dark-text-secondary mb-2">
                Status
              </label>
              <select
                value={filters.status || ''}
                onChange={(e) => handleFilterChange('status', e.target.value)}
                className="input-dark w-full"
              >
                <option value="">Todos</option>
                <option value="Concluída">Concluída</option>
                <option value="Aguardando">Aguardando Aprovação</option>
                <option value="Execução">Em Execução</option>
                <option value="Pendente">Pendente</option>
              </select>
            </div>

            

            {/* Problema */}
            <div>
              <label className="block text-sm font-medium text-dark-text-secondary mb-2">
                Problema (palavras-chave)
              </label>
              <input
                type="text"
                value={filters.problema || ''}
                onChange={(e) => handleFilterChange('problema', e.target.value)}
                placeholder="Ex: ar condicionado, elétrica..."
                className="input-dark w-full"
              />
            </div>

            {/* Técnico/Atendente */}
            <div>
              <label className="block text-sm font-medium text-dark-text-secondary mb-2">
                Técnico/Atendente
              </label>
              <input
                type="text"
                value={filters.tecnico || ''}
                onChange={(e) => handleFilterChange('tecnico', e.target.value)}
                placeholder="Nome do técnico ou atendente"
                className="input-dark w-full"
              />
            </div>

            {/* Data Início */}
            <div>
              <label className="block text-sm font-medium text-dark-text-secondary mb-2">
                Data Início
              </label>
              <input
                type="date"
                value={filters.dataInicio || ''}
                onChange={(e) => handleFilterChange('dataInicio', e.target.value)}
                className="input-dark w-full"
              />
            </div>

            {/* Data Fim */}
            <div>
              <label className="block text-sm font-medium text-dark-text-secondary mb-2">
                Data Fim
              </label>
              <input
                type="date"
                value={filters.dataFim || ''}
                onChange={(e) => handleFilterChange('dataFim', e.target.value)}
                className="input-dark w-full"
              />
            </div>
          </div>

          {/* Busca Rápida */}
          <div className="border-t border-gray-700 pt-4">
            <label className="block text-sm font-medium text-dark-text-secondary mb-2">
              Busca Rápida (todos os campos)
            </label>
            <input
              type="text"
              value={filters.busca || ''}
              onChange={(e) => handleFilterChange('busca', e.target.value)}
              placeholder="Buscar por qualquer informação..."
              className="input-dark w-full"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterPanel; 
